module.exports = __webpack_public_path__ + "assets/img/g3.ec409f19.jpg";